import React, { useCallback, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

import { useIsExpandedContext } from "components/BudgetBuilder/Overview/OverviewLineItemsList/OverviewLineItemsList";
import OverviewResearchTeamMemberRow
	from "components/BudgetBuilder/Overview/OverviewLineItemsList/OverviewResearchTeamMemberRow";
import { useTenantFormatter } from "components/BudgetBuilder/shared/TenantFormatter";
import Table from "components/Table";
import { budgetBuilderSelectors } from "store/selectors";
import { getPeriodSubtotal, getResearchTeamMemberDataByPeriodByMember } from "utils/budgetBuilder";

import styles from "./styles.css";

export const OverviewResearchTeam = () => {
	const { currencyFormatter } = useTenantFormatter();
	const { isExpandedState: { isResearchTeamExpanded }, isExpandedDispatch } = useIsExpandedContext();
	const setIsResearchTeamExpanded = useCallback(
		isExpanded => isExpandedDispatch({ type: "isResearchTeamExpanded", isExpanded }),
		[ isExpandedDispatch ],
	);

	useEffect(() => {
		isExpandedDispatch({ type: "isResearchTeamExpanded", isExpanded: true });
	}, [ isExpandedDispatch ]);
	const periodList = useSelector(budgetBuilderSelectors.periodRows);
	const researchTeamByPeriod = useSelector(budgetBuilderSelectors.researchTeamByPeriod);
	const memberData = useMemo(
		() => getResearchTeamMemberDataByPeriodByMember(researchTeamByPeriod, periodList.length),
		[ periodList.length, researchTeamByPeriod ],
	);
	const researchTeamTotal = useMemo(() => {
		let total = 0;
		for (let periodNumber in researchTeamByPeriod) {
			total += getPeriodSubtotal(researchTeamByPeriod[periodNumber], false);
		}

		return total;
	}, [ researchTeamByPeriod ]);

	return (
		<>
			{isResearchTeamExpanded && (
				<Table.Row>
					<Table.Cell className={`${styles.cellAlignLeft} ${styles.expandCell}`}>
						<span>{"Research Team"}</span>
						<div className={styles.expandIcon} onClick={() => setIsResearchTeamExpanded(!isResearchTeamExpanded)}>
							<i className="fa fa-caret-down" aria-hidden="true" />
						</div>
					</Table.Cell>
					{periodList?.map((item, i) => (
						<Table.Cell key={`period-${i}`}>
							<div className={styles.cellAlignSpread}>
								<span className={styles.bold}>{"Effort"}</span>
								<span className={styles.bold}>{"Amount"}</span>
							</div>
						</Table.Cell>
					))}
					<Table.Cell className={styles.cellAlignRight} />
				</Table.Row>
			)}
			{(isResearchTeamExpanded) && (Object.entries(memberData).map(([ i, items ]) => (
				<OverviewResearchTeamMemberRow
					key={`member-${i}`}
					items={items}
					index={i}
				/>
			)))}
			<Table.Row>
				<Table.Cell className={`${styles.cellAlignLeft} ${!isResearchTeamExpanded ? styles.expandCell : undefined}`}>
					<span className={isResearchTeamExpanded ? styles.bold : undefined}>
						{isResearchTeamExpanded ? "Research Team Total" : "Research Team"}
					</span>
					{!isResearchTeamExpanded && (
						<div className={styles.expandIcon} onClick={() => setIsResearchTeamExpanded(!isResearchTeamExpanded)}>
							<i className="fa fa-caret-right" aria-hidden="true" />
						</div>
					)}
				</Table.Cell>
				{periodList.map((period, i) => (
					<Table.Cell className={styles.cellAlignRight} key={`period-${i}`}>
						<span className={isResearchTeamExpanded ? styles.bold : undefined}>
							{currencyFormatter(getPeriodSubtotal(researchTeamByPeriod?.[period?.periodNumber], false))}
						</span>
					</Table.Cell>
				))}
				<Table.Cell className={styles.cellAlignRight}>
					<span className={styles.bold}>{currencyFormatter(researchTeamTotal)}</span>
				</Table.Cell>
			</Table.Row>
		</>
	);
};
